import React, { useState } from 'react';
import { Marcas as marcasData } from '../mockData';

const Marcas = () => {
  const [marcaActiva, setMarcaActiva] = useState(null);

  const toggleProductos = (id) => {
    setMarcaActiva(marcaActiva === id ? null : id);
  };

  return (
    <section id="Marcas" className="section marca-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Nuestras Marcas</h2>
          <p className="section-description">
            La confianza de nuestras herramientas
          </p>
        </div>

        <div className="marca-grid">
          {marcasData.map((marca) => (
            <div key={marca.id} className="marca-card">
              <div className="marca-logo-container">
                <img src={marca.logo} alt={marca.name} className="marca-logo" />
              </div>

              <div className="marca-content">
                <p className="marca-testimonial">{marca.testimonial}</p>
                <h4 className="marca-name">{marca.name}</h4>

                <button
                  className="productos-btn"
                  onClick={() => toggleProductos(marca.id)}
                >
                  Productos
                </button>

                {marcaActiva === marca.id && (
                  <div className="productos-panel">
                    {marca.productos.map((producto, index) => (
                      <div key={index} className="producto-item">
                        <img
                          src={producto.imagen}
                          alt={producto.nombre}
                          className="producto-img"
                        />
                        <div className="producto-info">
                          <h5>{producto.nombre}</h5>
                          <p>{producto.descripcion}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marcas;